'use client';

import { useEffectOnce } from '@carvana/merch-react-hooks';
import React from 'react';
import useSetDataDogContext from '~/hooks/dealership/useSetDataDogContext';
import initDataDog from '~/utilities/datadog';

const DATA_DOG_REPLAY_SAMPLE_RATE = 100;
const DATA_DOG_SAMPLE_RATE = 100;

type AppProps = {
  correlationId: string;
  dealershipId: string;
};

type OwnProps = React.PropsWithChildren<{
  appProps: AppProps;
}>;

export default function ForAppWrapper({ children, appProps }: OwnProps) {
  useSetDataDogContext(appProps.dealershipId);

  useEffectOnce(() => {
    initDataDog(
      appProps.correlationId,
      DATA_DOG_SAMPLE_RATE,
      DATA_DOG_REPLAY_SAMPLE_RATE
    );
  }, [appProps.correlationId]);

  return <>{children}</>;
}
